import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './layout/home-page/home-page.component';
import { NotFoundComponent } from './shared/not-found/not-found.component';

const routes: Routes = [
  { path: '', component: HomePageComponent },
  // { path: 'home/:name', pathMatch:'full', component: HomePageComponent },
  // { path: '**' , redirectTo:'not-found' },
  // { path: 'not-found',component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'ignore',
    scrollOffset: [0, 180]


  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
